import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Footer from '../../components/common/Footer';
import SubmitRes from '../../components/result/SubmitRes';
import './ApplyResult.scss';
let wxImg = 'https://cdn.fujfu.com/spreadAdviserQr.png';
class Login extends Component {
  toWx = () => {
      window.location.href = "https://cdn.fujfu.com/spreadAdviserRedirect.html"
  };
  render() {
    return (
      <div>
        <Helmet><title>申请结果</title></Helmet>
        <SubmitRes
          icon='success'
          mainText='递交申请成功'
          subText='申请结果请留意短信及电话通知'>
        </SubmitRes>
        <div className="addWxTitle">
          <p>添加专属顾问，急速通过审核</p>
          <p>领取《产品大纲》《推广资料》</p>
          <div className="addWxImg">
            <img id="imgName" src={wxImg} alt="" />
          </div>
          <p className="saveImg" >长按保存图片</p>
          {/*<div className="addWx" onClick={this.toWx.bind(this)}>*/}
          {/*  加微信&nbsp;领福利*/}
          {/*</div>*/}
        </div>
        <Footer></Footer>
      </div>
    )
  }
}

export default Login;
